export default function (state, value) {
    state.items = [];
    if (value && value.Items) {
        value.Items.forEach(i => {
            state.items.push({
                value: i.Id,
                label: i.Number,
                ...i,
            });
        })
    }
    state.loading = false;
    state.cbs.forEach(i => {
        i(state);
    });
    state.cbs = [];
}